const notablelientHoverBaseData = (userId, sellerId) => ({
    group: 'user_impressions',
    page: {
        name: 'seller_page'
    },
    seller: {
        id: sellerId
    },
    user: {
        id: userId
    }
});

const notableClientsBarEvent = (userId, sellerId) => {
    const baseData = notablelientHoverBaseData(userId, sellerId);
    return {
        ...baseData,
        type: 'notable_clients_above_fold_is_shown'
    };
};

const notableClientsAboutEvent = (userId, sellerId) => {
    const baseData = notablelientHoverBaseData(userId, sellerId);
    return {
        ...baseData,
        type: 'notable_clients_below_fold_is_shown'
    };
};

module.exports = {
    notablelientHoverBaseData,
    notableClientsBarEvent,
    notableClientsAboutEvent
};
